import React from "react";
import ModuleContent from "./ModuleContent";

export const ExpandedModule = ({ title, onClose, onNavigate }) => {
  // Array of all expanded module content. Includes expanded asset, list item names, and paths.
  // 'imgSrc' is for the alternate (sss-blue) module icons.
  const expandedModuleContent = {
    "Invoicing": {

      imgSrc: "assets/dashboard/module-icon-invoices.png",
      items: [
        { name: "Open Invocies", path: null },
        { name: "Invoice History", path: null },
      ],
    },


    "Proposals & Jobs": {
      imgSrc: "assets/dashboard/alt-module-icon-proposals.png",
      items: [
        { name: "Approve Proposals", path: "/proposals/approval-page" },
        { name: "Proposal History", path: null },
        { name: "Job History", path: null },
      ],
    },
    "Reports": {
      imgSrc: "assets/dashboard/module-icon-reports.png",
      items: [
        { name: "Dispatches", path: null },
        { name: "Trouble Calls", path: null },
        { name: "Call Log", path: null },
      ],
    },
    "Inspections & Violations": {
      imgSrc: "assets/dashboard/alt-module-icon-inspections.png",
      items: [
        {
          name: "Notification Letters",
          path: "/inspections-violations/notification-letters",
        }

      ],
    },

  };

  return (
    <div className="border border-1 rounded-md border-sss-blue mr-12 mb-8">
      <div className="flex justify-end mr-2 mt-2">
        <button onClick={onClose} className="w-4 h-4 mr-2">
          <img src="assets/dashboard/module-icon-min.png" alt="" />
        </button>
        <button onClick={onClose} className="w-4 h-4">
          <img src="assets/dashboard/module-icon-open.png" alt="" />
        </button>
      </div>
      <div className="pl-5 pr-10">
        <div className="mx-auto my-4">
          {expandedModuleContent[title] && (
            <ModuleContent
              title={title}
              imgSrc={expandedModuleContent[title].imgSrc}
              items={expandedModuleContent[title].items}
            />
          )}
        </div>
      </div>
    </div>
  );
};
